const InovasiLewatResearchPaper: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-xl font-semibold mb-3">📚 Student Symposium: Panggung Kreatif Siswa Menjadi Ilmuwan Muda</h2>

            <p className="mb-4">
                Student Symposium adalah acara keren di mana para siswa <span className="font-semibold text-gray-800">bisa menunjukkan hasil karya atau penelitian mereka</span> di depan teman-teman, guru, bahkan juri. Ini bukan lomba biasa, symposium adalah tempat untuk berbagi ide, belajar dari orang lain, dan tampil percaya diri!
            </p>

            <p className="mb-4">
                Penelitian yang dibawakan bisa bermacam-macam, mulai dari teknologi, sains, lingkungan, sampai isu sosial yang dekat dengan kehidupan sehari-hari. Yang penting, <span className="font-medium">ide dan semangat untuk mencari solusi</span> ditunjukkan lewat karya yang dipresentasikan.
            </p>

            <h3 className="text-lg font-semibold mb-2">✨ Tips Tampil Maksimal di Symposium:</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
                <li><span className="font-semibold">Gunakan bahasa sederhana:</span> Jelaskan dengan gaya bercerita agar mudah dipahami semua orang.</li>
                <li><span className="font-semibold">Buat tampilan menarik:</span> Pakai gambar, poster, atau slide presentasi yang penuh warna.</li>
                <li><span className="font-semibold">Latihan ngomong:</span> Latih presentasi di depan teman atau keluarga supaya makin lancar.</li>
            </ul>

            <blockquote className="border-l-4 pl-4 italic text-gray-600 mb-4">
                “Setiap ide hebat dimulai dari keberanian untuk berbagi.”
            </blockquote>

            <p>
                Lewat symposium, siswa belajar untuk <span className="font-semibold">percaya diri, berpikir kreatif, dan berani tampil di depan umum</span>. Siapa tahu, dari acara ini akan lahir ilmuwan muda atau inovator masa depan!
            </p>
        </div>
    )
}
export default InovasiLewatResearchPaper